export default {"src":"/_next/static/image/public/images/ic_non_returnable_info_icon.a9ec1094b730cd6d5f22e41c48211c37.svg","height":24,"width":24};